import { createThemedStyled, createThemedWithStyle, createThemedUseStyletron } from 'baseui';
import deepMerge from 'baseui/utils/deep-merge';

const styled = createThemedStyled();
const withStyle = createThemedWithStyle();
const useStyletron = createThemedUseStyletron();
const useResolvedStyle = ($style) => {
  const [, theme] = useStyletron();
  return typeof $style === "function" ? $style({ $theme: theme }) : $style;
};
const mergeStyles = (target, source) => deepMerge(target, source);

export { mergeStyles, styled, useResolvedStyle, useStyletron, withStyle };
